import { render, staticRenderFns } from "./AboutOverview.vue?vue&type=template&id=416b4d71&scoped=true"
import script from "./AboutOverview.vue?vue&type=script&lang=js"
export * from "./AboutOverview.vue?vue&type=script&lang=js"
import style0 from "./AboutOverview.vue?vue&type=style&index=0&id=416b4d71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416b4d71",
  null
  
)

export default component.exports